import React from 'react';
import useTheme from 'branding/theme';
import withHover from '../../hocs/withHover';
import RadioCircle from '../../graphics/RadioCircle';
import ChoiceLabel from '../../typography/ChoiceLabel';
import AccessiblyHiddenChoice from '../AccessiblyHiddenChoice';
import withFocus from '../../hocs/withFocus';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
export const Radio = React.forwardRef(({ id, className, labelText, name, value, disabled = false, checkedValue, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleBlur, handleFocus, onBlur, onChange, styles, children, status = 'success' }, ref) => {
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const isSelected = value === checkedValue;
    const { inputs: { choiceStyles } } = useTheme();
    const mergedStyles = {
        ...choiceStyles.base,
        ...(!disabled && isHovered && choiceStyles.hovered),
        ...styles
    };
    const label = React.useMemo(() => {
        if (children) {
            return children;
        }
        return (React.createElement(ChoiceLabel, { htmlFor: id, disabled: disabled }, labelText));
    }, [id, disabled, labelText, children]);
    return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React.createElement("label", { className: className, style: mergedStyles, 
        // putting `tabIndex` here would hinder accessibility
        onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: focusHandlers.onFocus, onBlur: focusHandlers.onBlur },
        React.createElement(AccessiblyHiddenChoice, { type: "radio", id: id, name: name, disabled: disabled, isHovered: isHovered, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, value: value, onChange: onChange, handleBlur: handleBlur, ref: ref, ...focusHandlers }),
        React.createElement(RadioCircle, { status: status, isSelected: isSelected, isFocused: isFocused, isHovered: isHovered, disabled: disabled }),
        label));
});
export default withHover(withFocus(withFormProps(Radio)));
//# sourceMappingURL=index.js.map